import type { Fetch } from '../types'

import { useSablierController } from '@/features/interface/sablier/useSablierController'

export function configSablier(nextFetch: Fetch): Fetch {
  const controller = useSablierController()
  return async function (input: RequestInfo | URL, init?: RequestInit) {
    const estSablierActif = init?.sablier === true
    try {
      if (estSablierActif) controller.debutSablier()
      return await nextFetch(input, init)
    } finally {
      if (estSablierActif) controller.finSablier()
    }
  }
}

